<template>
    <div class="register_main_left">
        <img 
            class="floating" 
            src="../../../../static/prism/images/login_page_icons/17.png" 
            style="position:absolute;top: 45%;right: 75px;" alt="#"
        />
        <img 
            class="fadeIn" 
            src="../../../../static/prism/images/regpercentage.png" 
            style="position:absolute;top: 15%;right: 145px;" alt="#" 
        />
        <img 
            class="fadeIn" 
            src="../../../../static/prism/images/regtopcircle.png" 
            style="position:absolute;top:-60px;left: -80px;" alt="#" 
        />
        
        <div class="lr-left-info-section d-flex">
            <div class="lr-left-info-section-top">
                <div class="heading-left">
                    <h1 class="first-heading">Open a FREE</h1>
                    <h1 class="second-heading">Demat & <br>Trading Account</h1>
                </div>
                <!-- <h1>completely commission</h1> -->
                <!-- <img class="freeTag slideDown" src="../../../../static/prism/images/regfree.svg"/> -->
                <div class="sub-slide-left-info-section d-flex">
                    <div class="sub-slis-img">
                        <img class="bigEntrance" src="../../../../static/prism/images/big_zero.png" />
                    </div>
                    <div id="regSlider" class="carousel slide vertical" data-ride="carousel">
                        <div class="slider-wrapper carousel-inner">
                            <div class="carousel-item active">
                                <div class="sub-slis-text">
                                    <label>Account Opening<br> & AMC Charges</label>
                                    <!-- <span>Intraday | Delivery | Futures | Options</span> -->
                                </div>
                                
                            </div>
                            <div class="carousel-item">
                                <div class="sub-slis-text">
                                    <label>Call and Trade<br> Charges</label>
                                    <!-- <span>Currency | Commodities | Direct Mutual Funds</span> -->
                                </div>
                                
                            </div>
                            <div class="carousel-item">
                                <div class="sub-slis-text">
                                    <label>Auto Squared-off<br> Charges</label>
                                    <!-- <span>Intraday | Delivery | Futures | Options</span> -->
                                </div>
                                
                            </div>
                        </div>
                        <ul class="carousel-indicators" style="visibility: hidden;">
                        <li data-target="#regSlider" data-slide-to="0" class="active"><span></span></li>
                        <li data-target="#regSlider" data-slide-to="1"><span></span></li>
                        <li data-target="#regSlider" data-slide-to="2"><span></span></li>
                    </ul>
                    </div>
                    
                </div>
            </div>
            <div class="lr-left-info-section-bottom">
                <div class="sub-stats-left-info-section d-flex">
                    <div class="substats pl-0">
                        <span class="counter">{{countOne}}+</span>
                        <label>Years of expertise</label>
                    </div>
                    <div class="substats border-substats">
                        <span class="counter">{{countTwo}}L+</span>
                        <label>Trusted customers</label>
                    </div>
                    <div class="substats">
                        <span class="counter">{{countThree}}k+</span>
                        <label>Daily active clients</label>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { prismMixins } from '@/plugins/prism'
export default {
    name: 'REGISTER_LEFTBAR',
    mixins: [prismMixins],
    data() {
        return {
            countOne:0,
            countTwo:0,
            countThree:0,
            intervalOne: null,
            intervalTwo: null,
            intervalThree: null
        }
    },
    components: {},
    conputed:{

    },
    methods: {},
    watch:{
        countOne(cO){
            if(cO==11){
                clearInterval(this.intervalOne)
            }
        },
        countTwo(cT){
            if(cT==4){
                clearInterval(this.intervalTwo)
            }
        },
        countThree(cT){
            if(cT==100){
                clearInterval(this.intervalThree)
            }
        }
    },
    mounted () {
        $('.carousel').carousel({
	        interval: 4000
        })
        this.intervalOne = setInterval(() => {
            this.countOne++
        }, 100)
        this.intervalTwo = setInterval(() => {
            this.countTwo++
        }, 200)
        this.intervalThree = setInterval(() => {
            this.countThree++
        }, 80)
    }
}
</script>

<style>
.vertical .carousel-inner {
  height: 100%;
}
.heading-left {
    padding-left: 28px !important;
}
.first-heading {
    font-size: 27px !important;
    line-height: 48px !important;
    text-transform: none !important;
    letter-spacing: 0.1px;
}
.second-heading {
    font-size: 50px !important;
    line-height: 51px !important;
    letter-spacing: 0.1px;
}
.carousel.vertical .carousel-item {
  -webkit-transition: 1s ease-in-out top;
     -moz-transition: 1s ease-in-out top;
      -ms-transition: 1s ease-in-out top;
       -o-transition: 1s ease-in-out top;
          transition: 1s ease-in-out top;
          transform: inherit;
}

.carousel.vertical .active {
  top: 0;
  z-index: 1;
}

.carousel.vertical .next.carousel-item-left,
.carousel.vertical .prev.carousel-item-right {
  top: 0;
}

.carousel.vertical .active.carousel-item-left {
  top: -100px;
}

.carousel.vertical .active.carousel-item-right {
  top: 100px;
}

.carousel.vertical .carousel-item {
    left: 0;
    background: #3b3c3f;
}
.display-none {
    display: none !important;
}

.register_main_left{
    position: relative;
    z-index: 2;
}

.lr-left-info-section-top {
    padding: 68px 74px 35px 100px;
}

.lr-left-info-section-bottom {
    padding: 10px 74px 35px 100px;
    background: linear-gradient(180deg, rgba(159, 159, 159, 0.24) 0%, rgba(0, 0, 0, 0) 50.34%);
}

.lr-left-info-section {
    background: linear-gradient(180deg, #3B3C3F -0.13%, #3B3C3F 100.13%);
    border-radius: 0 10px 50px 0;
    margin-left: -15px;
    width: 100%;
    max-width: 695px;
    flex-direction: column;
}

.lr-left-info-section span {
    color: #D9D9D9;
    display: block;
    font-size: 16px;
}
.freeTag{
    position: absolute;
    right: 4px;
    top: 145px;
}
.lr-left-info-section h1 {
    color: #fff;
    display: block;
    font-size: 58px;
    text-transform: capitalize;
    font-weight: 700;
    line-height: 67px;
}

.sub-slide-left-info-section {
    display: block;
    margin-top: 34px;
}

.sub-slis-text label {
    color: #FFF;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px;
    /* 125% */
    text-transform: capitalize;
}

.sub-slis-text span {
    color: #EFCD7F;
    font-size: 12px;
}


.sub-slis-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.slider-wrapper{
    overflow: hidden;
    height: 98px;
    float: left;
    margin-top: 33px;
    width: 300px;
}
.slider-wrapper div {
  height: 98px;
  box-sizing: border-box;
}

.sub-stats-left-info-section {
    padding-top: 30px;
}

.substats span {
    color: #E8C26D;
    font-family: Sora;
    font-size: 42px;
    width: 120px;
    font-style: normal;
    font-weight: 700;
    line-height: 37px;
    /* 88.095% */
    text-transform: capitalize;
}

.substats label {
    color: #D9D9D9;
    font-family: Sora;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 125% */
    text-transform: capitalize;
}

.substats {
    padding: 0px 40px;
}

.border-substats {
    border-left: 1px solid rgb(218 218 218 / 10%);
    border-right: 1px solid rgb(218 218 218 / 10%);
}
/* @media only screen and (max-width: 1614px) {

} */

.wipe-in {
  opacity: 1;
  transition: transform 3s, opacity 3s;
  transform: translateY(-100%);
}

.wipe-out {
  opacity: 0;
  transition: transform 2700ms, opacity 2700ms;
  transform: translateY(-200%);
}

</style>


// WEBPACK FOOTER //
// src/components/prism/Users/register_left_section.vue